import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'

const fetchCourseById = async (courseId) => {
  const client = await getApi('schools', { version: 3 })
  const response = await client.get(`/courses/${courseId}`)
  return response.data
}

export const useGetCoursesById = (courseId) => {
  const queryClient = useQueryClient()

  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['course', courseId],
    queryFn: () => fetchCourseById(courseId),
    enabled: !!courseId // solo ejecuta si existe courseId
  })

  return {
    data,
    loading: isLoading,
    error,
    mutate: refetch
  }
}
